import "./Avatar.scss"

import React, { FunctionComponent } from "react"

interface IAvatarProps {
    text?: string
    theme?: "black" | "brand"
}

const Avatar: FunctionComponent<React.PropsWithChildren<IAvatarProps>> = ({
    text,
    theme,
}) => {
    return (
        <div className={`avatar avatar--theme-${theme}`}>
            {text}
        </div>
    )
}

export default Avatar
